export default {
    meta: {
        title: '拓店宝-收益预估结果'
    }
};
